export const filteredRowsData = (
  columns,
  rowsData,
  searchTerm,
  keysProp = null
) => {
  // по колонке ищем в field, а если его нет — в name (как и в панели просмотра)
  let keys =
    keysProp ||
    columns?.map((item) => (typeof item?.field === "string" ? item.field : item?.name));
  keys = keys.filter(
    (item) => !!item && (typeof item === "number" || typeof item === "string")
  );
  const term = searchTerm.toLowerCase();
  // имя колонки может отличаться от ключа в данных регистром (Email / email) —
  // сопоставляем ключи один раз по первой строке, а не для каждой строки
  const sample = rowsData?.[0] || {};
  const sampleKeys = Object.keys(sample);
  const resolvedKeys = keys.map((key) => {
    if (key in sample) return key;
    return sampleKeys.find((k) => k.toLowerCase() === String(key).toLowerCase()) || key;
  });
  return rowsData?.filter((item) => {
    return !!resolvedKeys.find((key) => {
      const value = item[key];
      return value !== undefined && value !== null && String(value).toLowerCase().includes(term);
    });
  });
};

export const filteredGroupRowsData = (
  columns,
  rowsData,
  searchTerm,
  groupProps = { groupNameProp: "", groupChildrenProp: "", childrenKeys: null }
) => {
  const groupFiltered = filteredRowsData(null, rowsData, searchTerm, [
    groupProps.groupNameProp,
  ]);
  const filtered = rowsData?.map((item) => {
    const isExist = groupFiltered?.find(
      (group) =>
        item[groupProps.groupNameProp] === group[groupProps.groupNameProp]
    );
    return isExist
      ? item
      : {
          ...item,
          [groupProps.groupChildrenProp]: filteredRowsData(
            columns,
            item[groupProps.groupChildrenProp],
            searchTerm,
            groupProps.childrenKeys
          ),
        };
  });
  return filtered?.filter(
    (item) => !!item[groupProps.groupChildrenProp]?.length
  );
};
